import { Tooltip } from 'antd';
import { motion } from 'framer-motion';
import { twMerge } from '@utils/twMerge';
import { AlertIcon } from '@dynamika-shared/ui/icons';
import { d7Format } from '@dynamika-shared/utils/date';
import { QCVisitExtendedWithContextDataAndDates } from '../../hooks/useMergedVisits.hook';

type Props = {
  visit: QCVisitExtendedWithContextDataAndDates;
  isCurrentVisit: boolean;
  isReorderingMode: boolean;
};

export const VisitTabLabel = ({
  visit,
  isCurrentVisit,
  isReorderingMode,
}: Props) => {
  const isUnscheduled = visit.type === 'UNSCHEDULED' && !visit?.earlyTerminated;

  return (
    <Tooltip
      color='white'
      className='flex flex-col items-center justify-center gap-1'
      title={
        <span className='text-1424 text-black'>
          {!visit.taskId ? 'No data for current visit' : visit.visitName}
        </span>
      }
    >
      <motion.div
        layout
        transition={{ duration: isReorderingMode ? 0.3 : 0 }}
        className={twMerge(
          'px-2 py-1 rounded-2xl border-2',
          isCurrentVisit
            ? 'border-dashed border-dodgerBlue text-honoluluBlue bg-waterLightHover50'
            : 'border-transparent text-gray-600 bg-transparent'
        )}
      >
        <div
          className={twMerge(
            'flex items-center justify-center gap-1',
            !visit.visitOrderLocked ? 'unscheduled-visit' : 'scheduled-visit'
          )}
        >
          {!visit.visitOrderLocked && !isReorderingMode && (
            <AlertIcon className='h-2 w-2 text-vermilion' />
          )}
          <div
            className={twMerge(
              'text-1624 flex gap-[4px]',
              !visit.taskId && 'disabledTab',
              isCurrentVisit && 'bg-body',
              isReorderingMode && 'bg-transparent'
            )}
          >
            {isUnscheduled ? (
              <>
                <span>Unscheduled</span>
                <span className='text-dimGray'>•</span>
                <span>
                  {d7Format(visit?.visitName ?? '', 'dd-MMM-yyy')}
                </span>
              </>
            ) : (
              <span>{visit.visitName}</span>
            )}
          </div>
        </div>
        {isReorderingMode && (
          <span className='text-dimGray text-1216'>{visit.visitDate}</span>
        )}
      </motion.div>
    </Tooltip>
  );
};
